import React, { Fragment } from "react";
import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import ADDRES from "../../../assets/ADDRES.png";
import Agency_Name from "../../../assets/Agency_Name.png";
import Email from "../../../assets/Email.png";
import Phone from "../../../assets/Phone.png";
import POC from "../../../assets/POC.png";

// import {
//     blue,
//     blueGrey
//   } from '@mui/material/colors'
//   import {
//     createTheme
//   } from '@mui/material/styles';

// const theme = createTheme({
//     palette: {
//         primary: {
//             main: blueGrey[900],
//         },
//         secondary: {
//             main: blueGrey[300],
//         },
//     },
//   });
// Register the Roboto font
Font.register({
  family: "Roboto",
  fonts: [
    { src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Me5Q.ttf" },
    {
      src: "https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  boldLabel: {
    fontWeight: "bold",
  },
  invoiceNoContainer: {
    flexDirection: "row",
    fontSize: 8.5,
  },
  invoiceDateContainer: {
    flexDirection: "row",
    fontSize: 8.5,
  },
  headerRow: {
    flexDirection: "row",
    backgroundColor: "#263238",
    fontWeight: "bold",
    color: "white",
    fontSize: 8.5,
    marginTop: "10px",
  },
  KOsHeader: {
    fontSize: 8.5,
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    width: "35%",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#263238",
  },
  COsHeader: {
    fontSize: 8.5,
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    width: "35%",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#263238",
  },
  QuoteInfoHeader: {
    fontSize: 8.5,
    padding: "3px",
    textAlign: "left",
    fontWeight: "bold",
    width: "20%",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#263238",
  },
  invoiceDate: {
    fontSize: 8.5,
    // fontStyle: "bold", error
    fontWeight: "bold",
    textAlign: "right",
  },
  label: {
    width: 60,
    fontSize: 8.5,
    fontWeight: "bold",
    fontFamily: "Roboto",
  },
  Total_Con: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#263238",
  },
  KosHeaderContainer: {
    justifyContent: "flex-start",
    borderColor: "#263238",
    fontSize: 8.5,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    padding: "3px",
    width: "35%",
  },
  Date_Inv_Con: {
    flexDirection: "column",
    borderColor: "#263238",
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    width: "20%",
    borderColor: "#263238",
    padding: "3px",
  },
  QuotedTo: {
    borderColor: "#263238",
    fontSize: 8.5,
    padding: "3px",
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    width: "35%",
  },
  Quote_label: {
    width: 70,
    fontSize: 8.5,
    fontWeight: "bold",
    fontFamily: "Roboto",
  },
  KOsLabels: {
    width: "70px",
    fontSize: 8.5,
    fontWeight: "bold",
    fontFamily: "Roboto",
  },
  KOsLabelsFlow: {
    flexDirection: "row",
    fontFamily: "Roboto",
  },
  Gap1: {
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    width: "5%",
    backgroundColor: "#fff",
  },
  Gap2: {
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    width: "5%",
    backgroundColor: "#fff",
  },
  EmailColor: {
    color: "#0d47a1",
    textDecoration: "underline",
  },
});

const InvoiceNo = ({ invoice }) => (
  <Fragment>
    <View style={styles.headerRow}>
      <Text style={styles.KOsHeader}>Customer Details</Text>
      <View style={styles.Gap1}></View>
      <Text style={styles.COsHeader}>Ship To</Text>
      <View style={styles.Gap1}></View>
      <Text style={styles.QuoteInfoHeader}>Quote Info</Text>
    </View>

    <View style={styles.Total_Con}>
      <View style={styles.KosHeaderContainer}>
        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Agency Name:</Text>
          <Text>
            {invoice.Shipping_Details.Organization_Name
              ? invoice.Shipping_Details.Organization_Name
              : "N/A"}
          </Text>
        </View>
        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Poc: </Text>
          <Text>{invoice.KO_name ? invoice.KO_name : "N/A"}</Text>
        </View>
        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Address:</Text>
          <Text>{invoice.KO_address ? invoice.KO_address : "N/A"}</Text>
        </View>
        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Email:</Text>
          <Text style={styles.EmailColor}>
            {invoice.KO_email ? invoice.KO_email : "N/A"}
          </Text>
        </View>
        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Ph:</Text>
          <Text>{String(invoice.KO_phone ? invoice.KO_phone : "N/A")}</Text>
        </View>
      </View>

      <View style={styles.Gap2}></View>
      <View style={styles.QuotedTo}>
        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Name:</Text>
          <Text>
            {invoice.Shipping_Details.Customer_Name
              ? invoice.Shipping_Details.Customer_Name
              : "N/A"}
          </Text>
        </View>

        {/* <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Address:</Text>
          <Text>
            {invoice.Shipping_Details.Customer_Address
              ? invoice.Shipping_Details.Customer_Address
              : "N/A"}
          </Text>
        </View> */}
        <View>
          <View style={styles.KOsLabelsFlow}>
            <Text style={[styles.KOsLabels]}>Address:</Text>
          </View>
          <View style={{ flexDirection: "column", paddingLeft: 4 }}>
            {Array.isArray(invoice.Shipping_Details.Customer_Address) ? (
              invoice.Shipping_Details.Customer_Address.map((line, i) => (
                <Text key={i} style={{ fontSize: 8.5 }}>
                  {line}
                </Text>
              ))
            ) : (
              <Text style={{ fontSize: 8.5 }}>
                {invoice.Shipping_Details.Customer_Address ?? "N/A"}
              </Text>
            )}
          </View>
        </View>

        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Email:</Text>
          <Text style={styles.EmailColor}>
            {invoice.Shipping_Details.Customer_Email
              ? invoice.Shipping_Details.Customer_Email
              : "N/A"}
          </Text>
        </View>

        <View style={styles.KOsLabelsFlow}>
          <Text style={[styles.KOsLabels]}>Ph:</Text>
          <Text>
            {String(
              invoice.Shipping_Details.Customer_Phone
                ? invoice.Shipping_Details.Customer_Phone
                : "N/A",
            )}
          </Text>
        </View>
      </View>

      <View style={styles.Gap2}></View>

      <View style={styles.Date_Inv_Con}>
        <View style={styles.invoiceNoContainer}>
          <Text style={styles.label}>Quote#: </Text>
          <Text style={styles.invoiceDate}>
            {String(invoice.invoice_num ? invoice.invoice_num : "N/A")}
          </Text>
        </View>
        <View style={styles.invoiceDateContainer}>
          <Text style={styles.label}>Date: </Text>
          <Text style={styles.invoiceDate}>
            {String(invoice.trans_date ? invoice.trans_date : "N/A")}
          </Text>
        </View>

        {invoice.Valid_For !== "" && (
          <View style={styles.invoiceDateContainer}>
            <Text style={styles.label}>Valid For: </Text>
            <Text style={styles.invoiceDate}>
              {String(invoice.Valid_For ? invoice.Valid_For : "N/A")}
            </Text>
          </View>
        )}
        {invoice.Contract_Vehicle === "GSA" && (
          <View style={styles.invoiceDateContainer}>
            <Text style={styles.Quote_label}>Quote Type: </Text>
            <Text style={styles.invoiceDate}>
              {invoice.Contract_Vehicle ? invoice.Contract_Vehicle : "N/A"}
            </Text>
          </View>
        )}

        <View style={styles.invoiceDateContainer}>
          <Text style={styles.label}>Print Date: </Text>
          <Text style={styles.invoiceDate}>
            {String(invoice.Print_Date ? invoice.Print_Date : "N/A")}
          </Text>
        </View>
      </View>
    </View>
  </Fragment>
);

export default InvoiceNo;
